import { call, put, takeLatest } from "redux-saga/effects";
import { IBaseResponse } from "../../../interfaces/base";
import {
  getUserStart,
  updateUserStart,
  updateUserSuccess,
  updateUserFailed,
  getUserFailed,
  getUserSuccess,
  deleteUserFailed,
  deleteUserSuccess,
  deleteUserStart,
} from "./user-slice";
import {
  IDeleteUserAction,
  IGetUserAction,
  IUpdateUserAction,
} from "../../../interfaces/store/user-interfaces";
import {
  deleteUserApi,
  getFitnessProfileByUserIdApi,
  getUserByIdApi,
  updateUserApi,
} from "../../../api/accounts";

function* _getUser({ payload }: IGetUserAction): any {
  try {
    const { userId } = payload;

    const response: IBaseResponse = yield call(getUserByIdApi, userId);

    if (response.error) {
      yield put(getUserFailed(response.error));
    } else {
      const userFitnessProfile: IBaseResponse = yield call(
        getFitnessProfileByUserIdApi,
        userId
      );

      yield put(
        getUserSuccess({
          data: { ...response.data, fitnessProfile: userFitnessProfile.data },
        })
      );
    }
  } catch (error: any) {
    yield put(getUserFailed({ message: error.message }));
  }
}

function* _updateUser({ payload }: IUpdateUserAction) {
  try {
    const { userId, user } = payload;

    const response: IBaseResponse = yield call(updateUserApi, user, userId);

    if (response.error) {
      yield put(updateUserFailed(response.error));
    } else {
      const userFitnessProfile: IBaseResponse = yield call(
        getFitnessProfileByUserIdApi,
        userId
      );

      yield put(
        updateUserSuccess({
          ...response.data,
          fitnessProfile: userFitnessProfile.data,
        })
      );
    }
  } catch (error: any) {
    yield put(updateUserFailed({ message: error.message }));
  }
}

function* _deleteUser({ payload }: IDeleteUserAction) {
  try {
    const { userId } = payload;

    const response: IBaseResponse = yield call(deleteUserApi, userId);

    if (response.error) {
      yield put(deleteUserFailed(response.error));
    } else {
      yield put(deleteUserSuccess(userId));
    }
  } catch (error: any) {
    yield put(deleteUserFailed({ message: error.message }));
  }
}

export function* userSaga() {
  yield takeLatest(getUserStart.type, _getUser);
  yield takeLatest(updateUserStart.type, _updateUser);
  yield takeLatest(deleteUserStart.type, _deleteUser);
}

export default userSaga;
